import { useMemo } from 'react';
import { Button, Checkbox, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { TermsOfServiceContent } from "../ClientOnboardingInnerV2/OnboardingPage/Steps/TermsOfService/TermsOfServiceContent";
import { StepPage } from "../../components/StepPage";
import styles from "./TermsOfServiceStep.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  TermsOfServiceStepTestIds
} = getTestIds();
export function TermsOfServiceStep(_ref) {
  var _relationship$legalTe2;
  let {
    relationship,
    termsOfService,
    onBack,
    onNext,
    isStatementAccepted,
    onStatementChange,
    shouldSignStatement,
    isPeview
  } = _ref;
  const termsOfServiceName = useMemo(() => {
    var _relationship$legalTe;
    if (((_relationship$legalTe = relationship.legalTermsDocuments) === null || _relationship$legalTe === void 0 ? void 0 : _relationship$legalTe.length) > 1) {
      return termsOfService.displayName.replace(/\.pdf$/i, '');
    }
    return "Terms of Service";
  }, [termsOfService.displayName, (_relationship$legalTe2 = relationship.legalTermsDocuments) === null || _relationship$legalTe2 === void 0 ? void 0 : _relationship$legalTe2.length]);
  const statement = useMemo(() => {
    return termsOfService.termsOfService.type === 'explicitApproval' ? termsOfService.termsOfService.explicitApproval.statement : null;
  }, [termsOfService.termsOfService]);
  return /*#__PURE__*/_jsx(StepPage, {
    header: "Review ".concat(termsOfServiceName),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      disabled: !isStatementAccepted,
      onClick: onNext,
      children: "Next"
    }),
    onBackBtnClick: onBack,
    contentClassName: styles.content,
    testId: TermsOfServiceStepTestIds.Root(),
    withinFooter: (isPeview || shouldSignStatement) && statement ? /*#__PURE__*/_jsx(Checkbox, {
      className: styles.statementCheckbox,
      onChange: e => onStatementChange(e.target.checked),
      testId: TermsOfServiceStepTestIds.StatementCheckbox(),
      checked: isStatementAccepted,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "light",
        children: statement
      })
    }) : null,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": TermsOfServiceStepTestIds.Content(),
      className: styles.termsOfServiceContent,
      children: /*#__PURE__*/_jsx(TermsOfServiceContent, {
        relationship: relationship,
        termsOfService: termsOfService
      })
    })
  });
}